// Sidebar.jsx
import React, { useState, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { usePermissions } from "../../../context/PermissionContext";
import "./Sidebar.css";

// Permission mapping for menu items
const MENU_PERMISSIONS = {
  Dashboard: "menu.dashboard",
  Users: "menu.users",
  UserList: "menu.users.list",
  RolePermission: "menu.users.roles",
  Products: "menu.products",
  Category: "menu.products.category",
  SubCategory: "menu.products.subcategory",
  AddProducts: "menu.products.add",
  Customers: "menu.customers",
  CustomerList: "menu.customers.list",
  Sales: "menu.sales",
  Orders: "menu.sales.orders",
  OrdersReport: "menu.sales.reports",
  SalesReports: "menu.sales.salesReports",
  CancelOrderReports: "menu.sales.cancelReports",
  Deliveries: "menu.deliveries",
  OrderArrived: "menu.deliveries.arrived",
  AcceptedOrders: "menu.deliveries.accepted",
  DeliveredOrders: "menu.deliveries.delivered",
  CancelledOrders: "menu.deliveries.cancelled",
  CustomerOrders: "menu.customer.orders",
  CustomerOrderReports: "menu.customer.order.reports",
  CustomerBillStatement: "menu.customer.bill.statement",
  CustomerCreditLimit: "menu.customer.credit.limit",
  Settings: "menu.settings",
  CompanySettings: "menu.settings.company",
  CustomerRequests: "menu.customer.requests",
  CreateCustomerRequest: "menu.customer.requests.create",
  MyCustomerRequests: "menu.customer.requests.my",
  SalesmanCustomers: "menu.customers.salesman",
  CashWallet: "menu.CashWallet",
  ChequeWallet: "menu.ChequeWallet",
  WalletMoney: "menu.wallet.money",
  paymentRequestsdelivery: "menu.paymentRequestsdelivery",
  paymentRequestssales: "menu.paymentRequestssales",
  billWallet: "menu.billWallet",
  AdminOrderRequests: "menu.admin.order.requests",
  storekeeperpacked: "menu.storekeeper.packed.orders",
  storekeeperRemainingPack: "menu.storekeeper.remaining.pack.orders",
  SalesPendingOrders: "menu.PendingOrders",
  SalesOutstandingReport: "menu.OutstandingReport",
  SalesReceiptReport: "menu.ReceiptReport",
  StorekeeperOrders: "menu.storekeeper.all-orders",
  CreditSuggestion: "menu.credit.suggestion",
  Emirates: "menu.emirates",
  SalesReturn: "menu.salesReturn",
  CreateSalesReturn: "menu.createSalesReturn",
  ReturnPickups: "menu.returnPickups",
  ReturnReceived: "menu.returnReceived",
  CashCollection: "menu.cashCollection",
  DeliveryPending: "menu.deliveryPending",
};

const navItems = [
  { id: "Dashboard", label: "Dashboard", icon: "📊", path: "/dashboard" },
  {
    id: "Users",
    label: "Users",
    icon: "👥",
    subItems: [
      { id: "UserList", label: "User", path: "/userlist" },
      { id: "RolePermission", label: "Role Permission", path: "/roles" },
    ],
  },
  {
    id: "Products",
    label: "Products",
    icon: "📦",
    subItems: [
      { id: "Category", label: "Category", path: "/category/list" },
      { id: "SubCategory", label: "Sub Category", path: "/subcategory/list" },
      { id: "AddProducts", label: "Add Products", path: "/product/list" },
    ],
  },
  {
    id: "Customers",
    label: "Customers",
    icon: "👥",
    subItems: [
      { id: "CustomerList", label: "Customers", path: "/customer/list" },
    ],
  },
  {
    id: "Sales",
    label: "Sales",
    icon: "📋",
    subItems: [
      { id: "Orders", label: "Orders", path: "/order/list" },
      {
        id: "OrdersReport",
        label: "Orders Report",
        path: "/OrderReports/list",
      },
      {
        id: "CancelOrderReports",
        label: "Cancel Order Reports",
        path: "/CancelOrderReports/list",
      },
      {
        id: "SalesPendingOrders",
        label: "Pending Orders",
        path: "/sales/pending-orders",
      },
    ],
  },

  {
    id: "SalesReports",
    label: "Sales Reports",
    icon: "📈",
    path: "/SalesReports/list",
  },
  {
    id: "CreateSalesReturn",
    label: "Sales Returns",
    icon: "↩️",
    path: "/sales-returns",
  },
  {
    id: "SalesOutstandingReport",
    label: "Outstanding Report",
    icon: "📈",
    path: "/sales/outstanding-report",
  },
  {
    id: "SalesReceiptReport",
    label: "Receipt Report",
    icon: "📈",
    path: "/sales/ReceiptReport",
  },
  {
    id: "AdminOrderRequests",
    label: " Order Requests",
    icon: "📋",
    path: "/admin/AdminOrderRequests",
  },


  {
    id: "Deliveries",
    label: "Deliveries",
    icon: "🚚",
    subItems: [
      {
        id: "OrderArrived",
        label: "Order arrived",
        path: "/Orderarrived/list",
      },
      {
        id: "AcceptedOrders",
        label: "Accepted Orders",
        path: "/AccepetdOrders/list",
      },
      {
        id: "DeliveredOrders",
        label: "Delivered Orders",
        path: "/DeliveredOrders/list",
      },
      {
        id: "CancelledOrders",
        label: "Cancelled Orders",
        path: "/CancelledOrders/list",
      },
      {
        id: "ReturnPickups",
        label: "Return Pickups",
        path: "/delivery/return-pickups",
      },
    ],
  },
  {
    id: "CustomerOrders",
    label: "Orders",
    icon: "📦",
    subItems: [
      {
        id: "CustomerOrdersList",
        label: "View Orders",
        path: "/customer/orders",
      },
    ],
  },

  {
    id: "CustomerOrderReports",
    label: "Order Reports",
    icon: "📈",
    subItems: [
      {
        id: "CustomerOrderReports",
        label: "Reports",
        path: "/customer/order-reports",
      },
    ],
  },
  {
    id: "CustomerBillStatement",
    label: "Bill Statement",
    icon: "🧾",
    subItems: [
      {
        id: "CustomerBillStatement",
        label: "View Bills",
        path: "/customer/bill-statement",
      },
    ],
  },
  {
    id: "CustomerCreditLimit",
    label: "Credit Limit",
    icon: "💳",
    subItems: [
      {
        id: "CustomerCreditLimit",
        label: "Credit Info",
        path: "/customer/credit-limit",
      },
    ],
  },
  {
    id: "CustomerRequests",
    label: "Customer Requests",
    icon: "📝",
    path: "/admin/customer-requests/pending",
  },
  {
    id: "WalletMoney",
    label: "Wallet Money",
    icon: "💰",
    path: "/admin/wallet-money",
  },
  {
    id: "billWallet",
    label: "Bill Wallet",
    icon: "💰",
    path: "/admin/BillWallet",
  },
  {
    id: "CashCollection",
    label: "Cash Collection",
    icon: "💵",
    path: "/admin/cash-collection",
  },
  {
    id: "DeliveryPending",
    label: "Delivery Pending",
    icon: "🚚",
    path: "/admin/delivery-pending",
  },
  {
    id: "CreateCustomerRequest",
    label: "Create Customer ",
    icon: "📝",
    subItems: [
      {
        id: "CreateCustomerRequest",
        label: "Create Request",
        path: "/sales/customer-requests/create",
      },
      {
        id: "MyCustomerRequests",
        label: "My Requests",
        path: "/sales/customer-requests/my",
      },
      { id: "SalesmanCustomers", label: "Customers", path: "/sales/customers" },
    ],
  },

  {
    id: "CashWallet",
    label: "Cash Wallet",
    icon: "💰",
    path: "/delivery/wallet",
  },
  {
    id: "ChequeWallet",
    label: "Cheque Wallet",
    icon: "💰",
    path: "/delivery/wallet/cheque",
  },
  {
    id: "paymentRequestsdelivery",
    label: "Payment Requests",
    icon: "💰",
    path: "/delivery/payment-requests",
  },
  {
    id: "paymentRequestssales",
    label: "Payment Requests",
    icon: "💰",
    path: "/sales/payment-requests",
  },
  {
    id: "CreditSuggestion",
    label: "Credit Suggestion",
    icon: "💡",
    path: "/manager/credit-suggestion",
  },
  {
    id: "storekeeperpacked",
    label: "All Orders",
    icon: "📦",
    path: "/storekeeper/packed-orders",
  },
  {
    id: "storekeeperRemainingPack",
    label: "Remaining Pack Orders",
    icon: "📦",
    path: "/storekeeper/remaining-pack-orders",
  },
  { 
  id: 'StorekeeperOrders', 
  label: 'Pack Orders', 
  icon: '📋',
  path: '/storekeeper/all-orders' 
},
{
  id: 'ReturnReceived',
  label: 'Return Received',
  icon: '↩️',
  path: '/storekeeper/return-received',
},
{
  id: 'SalesReturn',
  label: 'Sales Returns',
  icon: '↩️',
  path: '/sales-returns',
},
{
  id: 'Emirates',
  label: 'Emirates',
  icon: '🌍',
  path: '/emirates',
},
{
  id: "CompanySettings",
  label: "Company Settings",
  icon: "⚙️",
  path: "/company-settings",
},
];

const Sidebar = ({ isOpen, activeItem, onSetActiveItem, onClose, user }) => {
  const [expandedItems, setExpandedItems] = useState({});
  const navigate = useNavigate();
  const { hasPermission, loading } = usePermissions();

  // Filter nav items based on permissions AND hide Deliveries for Admin
  const filteredNavItems = useMemo(() => {
    if (loading) return [];

    let itemsToFilter = [...navItems];

    // Hide Deliveries and Customer Dashboard menus for Admin users
    if (user && user.role === "Admin") {
      itemsToFilter = itemsToFilter.filter(
        (item) =>
          item.id !== "Deliveries" &&
          item.id !== "CustomerOrders" &&
          item.id !== "CustomerOrderStatus" &&
          item.id !== "CustomerOrderReports" &&
          item.id !== "CustomerBillStatement" &&
          item.id !== "CustomerCreditLimit" &&
          item.id !== "CreateCustomerRequest" &&
          item.id !== "CashWallet" &&
          item.id !== "ChequeWallet" &&
          item.id !== "paymentRequestsdelivery" &&
          item.id !== "paymentRequestssales" &&
          item.id !== "CreditSuggestion" &&
          item.id !== "storekeeperpacked" &&
          item.id !== "SalesOutstandingReport" &&
          item.id !== "SalesReceiptReport" &&
          item.id !== "ReturnPickups" &&
          item.id !== "ReturnReceived" &&
          item.id !== "CreateSalesReturn"
      );
    }

    itemsToFilter = itemsToFilter
      .filter((item) => {
        const itemPermission = MENU_PERMISSIONS[item.id];

        // Sales man and Sales Manager should not see the Create Sales Return shortcut in the sidebar
        // Both roles should only see the Sales Returns status page entry
        if (item.id === "CreateSalesReturn" && ["Sales man", "Sales Manager", "Customer"].includes(user?.role)) return false;
        if (item.id === "SalesReturn" && ["Sales man", "Sales Manager", "Customer"].includes(user?.role)) return true;

        // (removed ManageOrders menu)

        // A sub-item with its OWN mapped permission (e.g. "Sales Reports")
        // is gated independently — a role can be granted just that one
        // sub-item without the whole parent group's blanket permission, and
        // the group still shows up with only that sub-item visible. A
        // sub-item with NO permission mapping of its own (e.g. "View Orders"
        // under the Customer "Orders" menu) instead falls back to the
        // PARENT's permission — it has nothing else gating it, so skipping
        // the parent check entirely would make it visible to every role.
        if (item.subItems) {
          const filteredSubItems = item.subItems.filter((subItem) => {
            // Sales Manager cannot access "Orders" (create). Only Admin can.
            if (subItem.id === "Orders" && user?.role === "Sales Manager") {
              return false;
            }

            const subPermission = MENU_PERMISSIONS[subItem.id];
            if (subPermission) return hasPermission(subPermission);
            return !itemPermission || hasPermission(itemPermission);
          });

          // Only show parent if it has visible children
          return filteredSubItems.length > 0;
        }

        // If no permission required, show it
        if (!itemPermission) return true;

        return hasPermission(itemPermission);
      })
      .map((item) => {
        // Also filter subitems
        if (item.subItems) {
          const itemPermission = MENU_PERMISSIONS[item.id];
          return {
            ...item,
            subItems: item.subItems.filter((subItem) => {
              const subPermission = MENU_PERMISSIONS[subItem.id];
              if (subPermission) return hasPermission(subPermission);
              return !itemPermission || hasPermission(itemPermission);
            }),
          };
        }
        return item;
      });

    if (user?.role === "Customer") {
      const salesReturnIndex = itemsToFilter.findIndex((item) => item.id === "SalesReturn");
      const creditLimitIndex = itemsToFilter.findIndex((item) => item.id === "CustomerCreditLimit");
      if (salesReturnIndex !== -1) {
        const [salesReturnItem] = itemsToFilter.splice(salesReturnIndex, 1);
        const insertIndex = creditLimitIndex !== -1 ? creditLimitIndex + 1 : itemsToFilter.length;
        itemsToFilter.splice(insertIndex, 0, salesReturnItem);
      }
    }

    return itemsToFilter;
  }, [hasPermission, loading, user]);

  const toggleExpand = (itemId) => {
    setExpandedItems((prev) => ({
      ...prev,
      [itemId]: !prev[itemId],
    }));
  };

  const handleItemClick = (item, hasSubItems) => {
    if (hasSubItems) {
      toggleExpand(item.id);
    } else {
      onSetActiveItem(item.id);
      navigate(item.path);
      if (window.innerWidth < 768) {
        onClose();
      }
    }
  };

  const handleSubItemClick = (subItem) => {
    onSetActiveItem(subItem.id);
    navigate(subItem.path);
    if (window.innerWidth < 768) {
      onClose();
    }
  };

  if (loading) {
    return (
      <aside id="sidebar" className={`sidebar ${isOpen ? "open" : ""}`}>
        <div className="sidebar-loading">Loading...</div>
      </aside>
    );
  }

  return (
    <aside
      id="sidebar"
      className={`sidebar ${isOpen ? "open" : ""}`}
      aria-hidden={!isOpen}
    >
      <nav className="sidebar-nav" aria-label="Main navigation">
        <ul>
          {filteredNavItems.map((item) => {
            const hasSubItems = item.subItems && item.subItems.length > 0;
            const isExpanded = expandedItems[item.id];
            const isActive =
              activeItem === item.id ||
              (hasSubItems &&
                item.subItems.some((sub) => sub.id === activeItem));

            return (
              <li key={item.id}>
                <button
                  className={`nav-link ${isActive ? "active" : ""} ${hasSubItems ? "has-subitems" : ""}`}
                  onClick={() => handleItemClick(item, hasSubItems)}
                  aria-expanded={hasSubItems ? isExpanded : undefined}
                  aria-controls={hasSubItems ? `submenu-${item.id}` : undefined}
                >
                  <span className="nav-icon" aria-hidden="true">
                    {item.icon}
                  </span>
                  <span className="nav-label">{item.label}</span>
                  {hasSubItems && (
                    <span className="expand-icon" aria-hidden="true">
                      {isExpanded ? "▼" : "▶"}
                    </span>
                  )}
                </button>

                {hasSubItems && (
                  <ul
                    id={`submenu-${item.id}`}
                    className={`submenu ${isExpanded ? "open" : ""}`}
                    aria-hidden={!isExpanded}
                  >
                    {item.subItems.map((subItem) => (
                      <li key={subItem.id}>
                        <button
                          className={`nav-link sub-link ${activeItem === subItem.id ? "active" : ""}`}
                          onClick={() => handleSubItemClick(subItem)}
                          aria-current={
                            activeItem === subItem.id ? "page" : undefined
                          }
                        >
                          <span className="nav-label">{subItem.label}</span>
                        </button>
                      </li>
                    ))}
                  </ul>
                )}
              </li>
            );
          })}
        </ul>
      </nav>
    </aside>
  );
};

export default Sidebar;
